export const MatchType = {
    contains: 'contains',
    endsWith: 'endsWith',
    exact: 'exact',
    startsWith: 'startsWith',
} as const;

export type MatchType = keyof typeof MatchType;
